module.exports = __webpack_public_path__ + "img/photo-studio-atl-btl.54aa0a81.png";